import React, { Component } from 'react';
import Header from './../components/Header';
import InteractivePlan from './../components/InteractivePlan';
import Partners from './../components/Partners';

class JobfairPlanPage extends Component {
  render() {
    return (
      <div>
        <Header />
        <InteractivePlan svgPath="/static/ViK_2026_web_smaller.svg" svgPathMobile="/static/ViK_2026_web_smaller.svg"/>
        <Partners/>
      </div>
    );
  }
}

export default JobfairPlanPage;
